import orderConstants, { FormFiels } from './constants'
import * as common from "../../lib/common"

const initialState = {
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  warnings: [],
  users: [],
  usersChecked: [],
  customers: [],
  customerInfor: {},
  thuocs: [],
  thuocInfor: {},
  orderInfor: {},
  formData: null,
  enabledAddItem: false,
  typeOfOrder: orderConstants.TYPEOF_ORDER.FOR_DEFAULT,
  items: [],
  khoXuats: [],
  orderId: '',
  mode: orderConstants.MODE.IN_CREATE,
  callback: null,
  orderHistory: [],
  orderExport: {},
}

const reducer = function orderReducer(state = initialState, action) {
  let orderInfor = null

  switch (action.type) {
    case orderConstants.SET_MODE_FORM:
      return {
        ...state,
        mode: action.payload
      }
    case orderConstants.SET_CUSTOMERS:
      return {
        ...state,
        customers: action.payload
      }
    case orderConstants.SET_USERS_CHECKED:
      return {
        ...state,
        usersChecked: action.payload
      }
    case orderConstants.SET_FLAG_ADD_ITEM:
      return {
        ...state,
        enabledAddItem: action.payload
      }
    case orderConstants.SET_TYPEOF_ORDER:
      return {
        ...state,
        typeOfOrder: action.payload
      }
    case orderConstants.SET_ORDER_ID:
      return {
        ...state,
        errors: [],
        warnings: [],
        items: [],
        usersChecked: [],
        customerInfor: {},
        thuocInfor: thuocInfor,
        formData: null,
        orderInfor: {},
        orderId: action.payload,
      }
    case orderConstants.RESET_FORM:
      orderInfor = { items: [] }
      orderInfor[FormFiels.NgayLap] = common.currentDate()
      return {
        ...state,
        errors: [],
        warnings: [],
        items: [],
        khoXuats: [],
        usersChecked: [],
        customerInfor: {},
        customers: [],
        thuocInfor: {},
        formData: null,
        orderInfor: orderInfor,
        orderId: '',
        mode: orderConstants.MODE.IN_CREATE,
        callback: () => { }
      }
    case orderConstants.SET_CALLBACK_FUNC:
      return {
        ...state,
        callback: action.payload,
      }
    case orderConstants.UNLOCK_ORDER:
      return {
        ...state,
      }
    case orderConstants.SAVE_ORDER:
      return {
        ...state,
      }
    case orderConstants.SET_ORDER_INFOR:
      return {
        ...state,
        orderInfor: action.payload
      }
    case orderConstants.LOAD_USERS:
      return {
        ...state,
        formData: action.payload
      }
    case orderConstants.SET_USERS:
      return {
        ...state,
        users: action.payload
      }
    case orderConstants.SET_ITEM:
      let items = state.items
      const product = action.payload
      const existed = items.findIndex(x => x.product_id === product.product_id && x.is_km == product.is_km)
      if (existed >= 0) {
        items.splice(existed, 1)
      }
      items.push(product)

      return {
        ...state,
        items: items
      }
    case orderConstants.SET_ITEMS:
      return {
        ...state,
        items: action.payload
      }
    case orderConstants.SET_WARNING_ITEM:
      return {
        ...state,
        warnings: [{
          body: action.payload,
          time: new Date(),
        }],
      }
    case orderConstants.SET_MESSAGE:
      return {
        ...state,
        messages: [{
          body: action.payload,
          time: new Date(),
        }],
        errors: []
      }
    case orderConstants.SET_ERROR:
      return {
        ...state,
        messages: [],
        errors: [{
          body: action.payload,
          time: new Date(),
        }]
      }
    case orderConstants.SET_IS_LOADING:
      return {
        ...state,
        requesting: action.payload
      }
    case orderConstants.SET_THUOCS:
      return {
        ...state,
        thuocs: action.payload
      }
    case orderConstants.SET_THUOC_INFO:
      const thuocInfor = action.payload
      return {
        ...state,
        thuocInfor: action.payload
      }
    case orderConstants.LOAD_THUOCS:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.LOAD_THUOC_INFO:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.SET_KHOS:
      return {
        ...state,
        khoXuats: action.payload
      }
    case orderConstants.LOAD_KHOS:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.SET_ORDER_HISTORY:
      return {
        ...state,
        orderHistory: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.SET_ORDER_EXPORT:
      return {
        ...state,
        orderExport: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.LOAD_ORDER_DETAILS:
      return {
        ...state,
        messages: [],
        errors: []
      }
    case orderConstants.LOAD_CUSTOMER_INFO:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.SET_CUSTOMER_INFO:
      let customerInfor = action.payload
      orderInfor = state.orderInfor
      orderInfor[FormFiels.KhachHangId] = customerInfor.KhachHangId
      orderInfor[FormFiels.MaKhachHang] = customerInfor.MaKhachHang
      orderInfor[FormFiels.TenKhachHang] = customerInfor.Ten
      orderInfor[FormFiels.DiaChi] = customerInfor.DiaChi
      orderInfor[FormFiels.DienThoai] = customerInfor.DienThoai
      orderInfor[FormFiels.MaSoThue] = customerInfor.MaSoThue
      orderInfor[FormFiels.HdThamGia] = customerInfor.HdThamGia
      orderInfor[FormFiels.DiemTichLuy] = customerInfor.DiemTichLuy
      orderInfor[FormFiels.DsTichLuy] = customerInfor.DsTichLuy
      const setting = customerInfor.Setting && customerInfor.Setting != '' ? JSON.parse(customerInfor.Setting) : {}
      orderInfor[FormFiels.Setting] = setting

      return {
        ...state,
        customerInfor: customerInfor,
        orderInfor: orderInfor,
      }
    case orderConstants.LOAD_CUSTOMERS:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.DELETE_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case orderConstants.APPROVE_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case orderConstants.PROCESS_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case orderConstants.RETURN_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case orderConstants.REVERT_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case orderConstants.LOAD_ORDER_HISTORY:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.LOAD_ORDER_EXPORT:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case orderConstants.SET_ORDER_CONFIRM_MONEY:
      return {
        ...state,
        formData: action.payload
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Order/reducer.js